import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { fetchNsOptions } from '@/slices/utilSlice';
import ShadowCard from '@/components/ShadowCard';
import Subscription from './Subscription';
import Client from './Client';

function Message({ fetchNsOptions }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchNsOptions(clusterName);
    }
  }, [fetchNsOptions, clusterName]);

  return (
    <Root>
      <Tabs defaultValue='1'>
        <TabPanel value='1' label='订阅查询'>
          <Subscription />
        </TabPanel>
        <TabPanel value='2' label='客户端查询'>
          <Client />
        </TabPanel>
      </Tabs>
    </Root>
  );
}

export default connect(null, {
  fetchNsOptions,
})(Message);

const Root = styled(ShadowCard)`
  margin-right: 20px;
  .t-tabs__nav-item.t-is-active {
    color: var(--td-brand-color);
  }
  .t-tabs__nav-item {
    color: var(--td-text-color-primary);
  }
`;
